import * as React from "react";

import GuestLayout, {
  Content,
  SidePanel,
  BottomPanel
} from "components/layouts/guest-layout/guest-layout";

import FullscreenMessage from "../components/fullscreen-message.component";

type Props = {};

const ResetPasswordSuccessView: React.FC<Props> = () => (
  <GuestLayout>
    <SidePanel variant="login" />
    <Content>
      <FullscreenMessage
        variant="success"
        title="Success!"
        message={
          <span>
            A link to the password reset form was sent to your e-mail address.
            Please check your mailbox.
            <br />
            <br />
            Have a good day!
          </span>
        }
      />
    </Content>
    <BottomPanel variant="login" />
  </GuestLayout>
);

export default ResetPasswordSuccessView;
